import React from 'react';
import ThemeContext from '../Context';
export var containerId = 'react-ui-container';
var Provider = function Provider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      uiTheme: theme
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: containerId
  }, children));
};
Provider.displayName = 'ThemeProvider';
export default Provider;